import dynamic from 'next/dynamic';
export default dynamic(() => import(/* webpackChunkName: "blazePbGlobalLightbox" */'./GlobalLightbox'));
//# sourceMappingURL=index.js.map